import React, { useEffect, useRef, useState } from "react";
import Image from "./Image/Image";

// Define the props type
interface Product {
    image_url: string;
    title: string;
}

interface ImageSliderProps {
    products: Product[];
    //imageRatio: string;
}

const ImageSlider: React.FC<ImageSliderProps> = ({ products }) => {
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const intervalRef = useRef<number | null>(null);
    const currentIndexRef = useRef<number>(currentIndex); // Ref to store the current index
    // Update the ref whenever the state changes
    useEffect(() => {
        currentIndexRef.current = currentIndex;
    }, [currentIndex]);

    const handleMouseEnter = () => {
        // Start the interval on mouse hover
        intervalRef.current = window.setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex < products.length - 1 ? prevIndex + 1 : 0
            );
        }, 1000);
    };

    const handleMouseLeave = () => {
        // Clear the interval on mouse leave
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null; // Reset the interval reference
        }
        setCurrentIndex(0); // Reset index on mouse leave
    };

    useEffect(() => {
        // Cleanup interval when the component unmounts
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const goToSlide = (event: React.MouseEvent, index: number) => {
        event.stopPropagation();
        setCurrentIndex(index);
    };
    return (
        <div className="image-slider-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}  >
            {/* Image Slide */}
            <div className="slider">
                <figure className="mb-2 image is-4by5" >
                    {products[currentIndex]!=null?
                    <Image
                        src={products[currentIndex]?.image_url}
                        alt={products[currentIndex]?.title}
                        className="product-image"
                        loading="lazy"
                    />: <Image
                    src="../img"
                    alt=""
                    className="product-image"
                    loading="lazy"
                />}
                </figure>
            </div>

            {/* Circle Navigation */}
            <div className="hover-slider-info-container">
                <div className="circle-navigation">
                    {products.map((_, index) => (
                        <span
                            key={index}
                            onClick={(event) => goToSlide(event, index)} // Change to the corresponding slide
                            style={{
                                backgroundColor: currentIndex === index ? "#333" : "#ccc",
                            }}
                        ></span>
                    ))}
                </div>
            </div>


        </div>
    );
};

export default ImageSlider;
